export default __webpack_public_path__ + "static/media/img-1.5956dce9.png";